import { createUseStyles } from 'react-jss';
import { mobileContent } from '../../utils/mixins';
export default createUseStyles((theme) => (Object.assign({ container: {
        boxShadow: '0px 1px 3px #00000029',
        borderRadius: 5,
        padding: 20,
    }, regular: { backgroundColor: 'white' }, primary: { backgroundColor: theme.palette.primary.light }, secondary: { backgroundColor: theme.palette.secondary.light }, success: { backgroundColor: theme.palette.success.regular }, warning: { backgroundColor: theme.palette.warning.light }, danger: { backgroundColor: theme.palette.danger.regular } }, mobileContent({
    container: {
        maxWidth: 'calc(100vw - 55px)',
        overflowX: 'hidden',
    }
}))));
//# sourceMappingURL=styles.js.map